import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { useState } from 'react';
import { getItem } from "../../../../utils/localStorage";
import { makeRequest2 } from "../../../../utils/makeRequest";
import { toastify } from "../../../../utils/toast";
import { terminateContractUrl } from "../../../../utils/urls";

const TerminateContract = ({
    visible,
    onHide,
    contractId,
    contractName,
    onSuccess
}) => {
    const [terminationDate, setTerminationDate] = useState(new Date());
    const [terminationReason, setTerminationReason] = useState('');
    const [effectiveImmediately, setEffectiveImmediately] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleTerminate = async () => {
        try {
            setLoading(true);
            const facilityId = await getItem("selectedFacilityId");

            if (!effectiveImmediately && !terminationDate) {
                toastify("Please select a termination date", "error");
                setLoading(false);
                return;
            }

            const requestData = {
                terminationDate: effectiveImmediately ? null : terminationDate.toISOString(),
                terminationReason: terminationReason.trim(),
                effectiveImmediately
            };

            const response = await makeRequest2(
                `${terminateContractUrl}/${facilityId}/${contractId}`,
                "PATCH",
                requestData
            );

            if (response.success) {
                toastify("Contract terminated successfully", "success");
                handleClear();
                onHide();
                onSuccess();
            } else {
                throw new Error(response.error || "Failed to terminate contract");
            }
        } catch (err) {
            toastify(err.message || "Error terminating contract", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleClear = () => {
        setTerminationDate(new Date());
        setTerminationReason('');
        setEffectiveImmediately(false);
    };

    const dialogFooter = (
        <div>
            <Button
                label="Cancel"
                icon="pi pi-times"
                onClick={() => {
                    handleClear();
                    onHide();
                }}
                className="p-button-text"
                disabled={loading}
            />
            <Button
                label="Terminate"
                icon="pi pi-check"
                onClick={handleTerminate}
                className="p-button-danger"
                disabled={loading}
                loading={loading}
            />
        </div>
    );

    return (
        <Dialog
            visible={visible}
            style={{ width: '450px' }}
            header={`Terminate Contract: ${contractName || 'Contract'}`}
            modal
            className="p-fluid"
            footer={dialogFooter}
            onHide={onHide}
        >
            <div className="confirmation-content">
                <div className="alert alert-warning mb-3">
                    <i className="pi pi-exclamation-triangle mr-2"></i>
                    <span>This action cannot be undone. The contract will be permanently terminated.</span>
                </div>

                <div className="field mb-3">
                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="effectiveImmediately"
                            checked={effectiveImmediately}
                            onChange={(e) => setEffectiveImmediately(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="effectiveImmediately">
                            Terminate immediately
                        </label>
                    </div>
                </div>

                {!effectiveImmediately && (
                    <div className="field mb-3">
                        <label htmlFor="terminationDate" className="mb-2">Termination Date</label>
                        <Calendar
                            id="terminationDate"
                            value={terminationDate}
                            onChange={(e) => setTerminationDate(e.value)}
                            dateFormat="yy-mm-dd"
                            showIcon
                            className="w-100"
                            minDate={new Date()}
                        />
                    </div>
                )}

                <div className="field">
                    <label htmlFor="terminationReason" className="mb-2">Reason for Termination (Optional)</label>
                    <InputTextarea
                        id="terminationReason"
                        value={terminationReason}
                        onChange={(e) => setTerminationReason(e.target.value)}
                        rows={3}
                        placeholder="Enter reason for termination..."
                        className="w-100"
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default TerminateContract;